import React from 'react';
import PropTypes from 'prop-types';

const RecurringDeleteModal = ({ isOpen, onClose, deleteRecurringMode, setDeleteRecurringMode, onConfirm }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 overflow-y-auto h-full w-full z-50 flex justify-center items-center">
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full m-4 p-6">
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900">Delete Recurring Event</h3>
          <p className="text-sm text-gray-500 mt-2">
            This event is part of a recurring series. How would you like to delete it?
          </p>
        </div>
        
        <div className="space-y-3 mb-4">
          <div className="flex items-center">
            <input
              type="radio"
              id="delete-single"
              name="delete-mode"
              value="single"
              checked={deleteRecurringMode === 'single'}
              onChange={() => setDeleteRecurringMode('single')}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            />
            <label htmlFor="delete-single" className="ml-2 block text-sm text-gray-700">
              Delete only this occurrence
            </label>
          </div>
          
          <div className="flex items-center">
            <input
              type="radio"
              id="delete-future"
              name="delete-mode"
              value="future"
              checked={deleteRecurringMode === 'future'}
              onChange={() => setDeleteRecurringMode('future')}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            />
            <label htmlFor="delete-future" className="ml-2 block text-sm text-gray-700">
              Delete this and all future occurrences
            </label>
          </div>
          
          <div className="flex items-center">
            <input
              type="radio"
              id="delete-all"
              name="delete-mode"
              value="all"
              checked={deleteRecurringMode === 'all'}
              onChange={() => setDeleteRecurringMode('all')}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            />
            <label htmlFor="delete-all" className="ml-2 block text-sm text-gray-700">
              Delete all events in the series
            </label>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(deleteRecurringMode)}
            className="px-4 py-2 bg-red-600 text-white rounded-md shadow-sm hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

RecurringDeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  deleteRecurringMode: PropTypes.string.isRequired,
  setDeleteRecurringMode: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default RecurringDeleteModal;